module.exports = __webpack_public_path__ + "static/1026486992.2e25c085.jpg";